import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user/index.js';
import locales from './modules/locales/index.js';
import navigation from './modules/navigation.js';

Vue.use(Vuex);

const state = {
    loading: true
}

const getters = {
    loading: state => state.loading
}

const actions = {
    updateLoading: ({ commit }, loading) => commit('setLoading', loading)
}

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
}

const modules = { 
    user,
    locales,
    navigation,
}

export default new Vuex.Store({
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules
});


// WEBPACK FOOTER //
// ./src/store/index.js